<script lang="ts" setup>
import type {MultiChoice} from '@/ts/types/dto/interventions-dto';
import type {UuidDTO} from '@/ts/types/dto/sign-in-dto';
import {computed} from 'vue';

const props = defineProps<{
  question: MultiChoice;
  answers: UuidDTO[];
  customAnswer?: string;
}>();

const selectedOption = computed(() => {
  if (props.answers.length > 0) {
    return props.question.options.find(opt => opt.id === props.answers[0]);
  }
  return null;
});

const displayText = computed(() => {
  if (!selectedOption.value) {
    return '';
  }
  
  if (props.customAnswer) {
    return `${selectedOption.value.text}, ${props.customAnswer}`;
  }
  return selectedOption.value.text;
});
</script>

<template>
  <div class="dropdown-answer">
    <div class="selected-option">
      {{ selectedOption ? displayText : $t('no_user_input') }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dropdown-answer {
  display: flex;
  flex-direction: column;
}

.selected-option {
  padding: var(--Spacing-spacing-2) var(--Spacing-spacing-3);
  background-color: var(--Neutral-UI-neutral-ui-20);
  border-radius: var(--border-radius-sm);
  border: 1px solid var(--Neutral-UI-neutral-ui-40);
  font-weight: 500;
}
</style>